import { IGenericPayload } from "../../../../../../../models";
import { useAppDispatch, useAppSelector } from "../../../../../../../redux/hooks";
import { compileNameOfProperty, getGenericPayloadFromEvent } from "../../../../../../../utils";
import React, { useCallback } from "react";
import { IDropdownOption } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { MasterDocksFormStyle } from "./formStyle.jss";
import { FormField } from "../../../../../../common/fields/fields";
import { DefaultValues } from "../../../../../../../common/enum/DefaultValues";
import { BooleanSelector } from "../../../../../../request/common/selectors";
import { useForm } from "react-hook-form";
import { IMasterDisplayDoock } from "../../../../../../../models/resources/master/IDisplayDock";
import { updateMasterDocksProperty } from "../../../../../../../redux/reducers/resources/master/docks/form";
export const MasterDisplayDocksForm = () => {
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });
    const dispatch = useAppDispatch();

    const theme = useTheme();
    const style = MasterDocksFormStyle({ theme });
    const { register, control } = useForm<IMasterDisplayDoock>({ mode: "onChange" });

    const { form } = useAppSelector((state) => state.masterDocksForm);

    const onUpdateFormProperty = (name: string, value: any) => {
        const payload: IGenericPayload = {
            name,
            value,
        };
        dispatch(updateMasterDocksProperty(payload));
    };

    const onInputChange = useCallback(
        (event: any) => {
            const { name, value } = getGenericPayloadFromEvent(event);
            onUpdateFormProperty(name, value);
        },
        [dispatch],
    );

    const onYesNoOptionsChange = (option: IDropdownOption, propertyName: string) => {
        onUpdateFormProperty(propertyName, !!+option.key);
    };

    return (
        <div className={style.form}>
            <div className={style.rowForm}>
                <FormField
                    type="text"
                    label={t("CODE")}
                    value={form.code ?? DefaultValues.NOT_TEXT}
                    disabled={false}
                    {...register(compileNameOfProperty<IMasterDisplayDoock>("code"), {
                        onChange: onInputChange,
                        value: form.code ?? DefaultValues.NOT_TEXT,
                    })}
                    isRequired={true}
                    maxLength={64}
                />

                <FormField
                    type="text"
                    label={t("DESCRIPTION")}
                    value={form.description ?? DefaultValues.NOT_TEXT}
                    {...register(compileNameOfProperty<IMasterDisplayDoock>("description"), {
                        onChange: onInputChange,
                        value: form.description ?? DefaultValues.NOT_TEXT,
                    })}
                    isRequired={true}
                    maxLength={64}
                />
            </div>
            <div className={style.rowForm}>
                <BooleanSelector
                    onChange={onYesNoOptionsChange}
                    selectedKey={+form.active}
                    propertyName={compileNameOfProperty<IMasterDisplayDoock>("active")}
                    title={t("ACTIVE")}
                    control={control}
                    isRequired={true}
                />
            </div>
        </div>
    );
};
